import { HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { AuraUiChatAuth } from '@powerfleet/aura_standalone.ui';
import { KeycloakAuthService } from './keycloak-auth.service';

/**
 * Bridges the app's Keycloak auth to the Aura package's streaming auth abstraction.
 *
 * The AG-UI stream uses Fetch and therefore bypasses the Keycloak HttpInterceptor, so
 * the package asks the host to attach credentials to each run via `injectAuth`. The
 * non-streaming data path still authenticates through `keycloakAuthInterceptor`.
 */
@Injectable({ providedIn: 'root' })
export class AuraChatAuthService implements AuraUiChatAuth {
  private readonly keycloakAuthService = inject(KeycloakAuthService);

  async injectAuth(request: HttpRequest<unknown>): Promise<HttpRequest<unknown>> {
    const token = await this.getToken();
    return token
      ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : request;
  }

  /** Resolve a token for the Aura stream, never throwing (returns null if unavailable). */
  private async getToken(): Promise<string | null> {
    try {
      return await this.keycloakAuthService.getValidToken();
    } catch {
      return null;
    }
  }
}
